// Unauthorized.tsx
import React from 'react';

const Unauthorized = () => (
  <div className="text-center mt-20">
    <h1 className="text-3xl font-bold text-red-600">🚫 Không có quyền truy cập</h1>
    <p className="mt-4">Vui lòng quay lại trang chính hoặc đăng nhập bằng tài khoản có quyền.</p>
  </div>
);

export default Unauthorized;
